import { emailValidator, nameValidator, urlValidator } from '../../../globals/validations';

export default {
    address: {
        // validator: addressValidator,
        error: 'Please enter a valid address',
        required: true,
        stateConditions: {
            type: ['map'],
        },
    },
    cardImageURL: {
        error: 'Please select an image to upload',
        required: true,
        stateConditions: {
            cardBackground: ['custom'],
        },
    },
    isSmallSize: {
        stateConditions: {
            cardBackground: ['custom'],
        },
    },
    css: {
        error: 'Invalid css entered',

        required: true,
        stateConditions: {
            type: ['html'],
        }, // validator: addressValidator
    },
    html: {
        error: 'Invalid html entered',

        required: true,
        stateConditions: {
            type: ['html'],
        }, // validator: addressValidator
    },
    imageURL: {
        error: 'Please select an image to upload or change the content type.',
        required: true,
        stateConditions: {
            type: ['zoomImage'],
        },
    },
    isNameHidden: {},
    headerName: {},
    name: {
        error: 'Please enter a valid name',
        required: true,
        validator: nameValidator,
    },
    scrollableText: {
        error: 'Please enter valid text',
        required: true,
        stateConditions: {
            type: 'scrollableText',
        },
    },
    shouldUseCommonBackgroundImage: {},
    sitePageId: {
        error: 'Please select a site page',
        required: true,
        stateConditions: {
            type: ['canvas'],
        },
    },
    url: {
        error: 'Invalid url entered',
        required: true,
        stateConditions: {
            type: 'link'
        },
        validator: urlValidator,
    },
    description: {
        error: 'Please add a description',
        stateConditions: {
            type: 'info',
        },
    },
    contactName: {
        error: 'Please add a contact name',
        stateConditions: {
            type: 'info',
        },
    },
    additionalInformation: {
        error: 'Please add additional information',
        stateConditions: {
            type: 'info',
        },
    },
    documents: {
        error: 'Please add some documents',
        stateConditions: {
            type: 'info',
        },
    },
    email: {
        error: 'Please add a valid email address',
        stateConditions: {
            type: 'info',
        },
        validator: emailValidator,
    },
    facebookURL: {
        error: 'Please add a facebook link',
        stateConditions: {
            type: 'info',
        },
    },
    linkedInURL: {
        error: 'Please add a LinkedIn link',
        stateConditions: {
            type: 'info',
        },
    },
    phoneNumber: {
        error: 'Please add a phone number',
        stateConditions: {
            type: 'info',
        },
    },
    twitterURL: {
        error: 'Please add a twitter URL',
        stateConditions: {
            type: 'info',
        },
    },

    searchableList: {},
};
